import { useMutation } from '@tanstack/react-query';

import { ConfiguredToaster, ToastTitle } from '@app/shared/ui/sonner';

import { useShallow } from 'zustand/react/shallow';

import { updateWorkspace } from '../queries/updateWorkspace';
import { useSlideStore } from '../../store';
/**
 * Hook for updating workspace description
 * @param onSuccessCallback - Optional callback function to execute on successful update
 * @returns Mutation for updating workspace description
 */
export const useUpdateWorkspace = (onSuccessCallback?: () => void) => {
  const { setWorkspaceDescription } = useSlideStore(
    useShallow((state) => ({
      setWorkspaceDescription: state.setWorkspaceDescription,
    })),
  );

  const mutation = useMutation({
    mutationFn: updateWorkspace,
    onSuccess: (data, { description }) => {
      if (data.status) {
        setWorkspaceDescription(description);
        ConfiguredToaster.toastSuccess(<ToastTitle>Workspace description updated</ToastTitle>);
        // Вызываем callback для дополнительных действий (например, ревалидации)
        if (onSuccessCallback) {
          onSuccessCallback();
        }
      } else {
        ConfiguredToaster.toastError(
          <ToastTitle>Failed to update workspace description</ToastTitle>,
        );
      }
    },
    onError: (error) => {
      console.error('Error while updating workspace description:', error);
      ConfiguredToaster.toastError(
        <ToastTitle>Error while updating workspace description</ToastTitle>,
      );
    },
  });

  return mutation;
};
